import { Route, Routes } from '@angular/router';

import { RoutingData } from '@core/routing-data';
import { MainLayout } from '@layouts/main/main.layout';
import { FormLayout } from '@layouts/form/form.layout';
import { ConditionsLayout } from '@layouts/conditions/conditions.layout';
import { RoutingPages } from '@models/routing.model';
import { Language } from '@models/language.model';
import { iconResolver } from '@resolvers/icon.resolver';
import { navigationResolver } from '@resolvers/navigation.resolver';

const generateRoute = (page: RoutingPages, path: string, language: Language) => {
  const route = {
    path: path,
    component: page.component,
    title: page.title ? page.title[language as Language] : 'custom',
    data: { ...page.data, ...{ language: language, description: page.description } },
    loadComponent: page.loadComponent,
    resolve: {
      ...page.resolve,
      icons: iconResolver,
      navigation: navigationResolver
    },
    canActivate: page.canActivate,
    redirectTo: page.redirectTo ? page.redirectTo[language as Language] : undefined,
  };
  return route;
};

const setRoute = (page: RoutingPages, routes: Routes) => {
  const routeData = generateRoute(page, page.url[language as Language], language as Language);
  routes.push(routeData);
  if (page.routes) {
    for (const route of page.routes[language as Language]) {
      const routeData = generateRoute(page, route, language as Language);
      routes.push(routeData);
    }
  }
  if (page.numberOfParams) {
    let path: string = page.url[language as Language];
    for (let i = 0; i < page.numberOfParams; i++) {
      path += '/:param' + (i + 1);
      let pageCopy = { ...page };
      pageCopy.title = page.paramsTitle ?? page.title;
      pageCopy.description = page.paramsDescription ?? page.description;
      const routeData = generateRoute(pageCopy, path, language as Language);
      routes.push(routeData);
    }
  }
  return routes;
};

const routes: Routes = [];
const language: string = 'cs';
const mainRoutes: Route = { path: '', component: MainLayout, children: [] };
const formRoutes: Route = { path: '', component: FormLayout, children: [] };
const conditionsRoutes: Route = { path: '', component: ConditionsLayout, children: [] };

for (const page of RoutingData.pages) {
  if (!mainRoutes.children || !formRoutes.children || !conditionsRoutes.children) continue;
  if (page.type === 'forms') {
    formRoutes.children = setRoute(page, formRoutes.children);
  } else if (page.type === 'conditions') {
    conditionsRoutes.children = setRoute(page, conditionsRoutes.children);
  } else {
    mainRoutes.children = setRoute(page, mainRoutes.children);
  }
}

routes.push(mainRoutes);
routes.push(formRoutes);
routes.push(conditionsRoutes);
routes.push({ path: '**', redirectTo: '404' });

export { routes };
